"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ChangelogEntryController = /** @class */ (function () {
    function ChangelogEntryController(ChangelogModel, $state, $stateParams) {
        this.ChangelogModel = ChangelogModel;
        this.$state = $state;
        this.entry = null;
        this.loading = false;
        this.error = "";
        this.notFound = false;
        this.onBack = this.handleBack.bind(this);
        this.fetch(parseInt($stateParams["entry_id"], 10));
    }
    ChangelogEntryController.prototype.handleBack = function () {
        this.$state.go("drivecoach.admin.changelog");
    };
    ChangelogEntryController.prototype.fetch = function (id) {
        var _this = this;
        if (isNaN(id)) {
            this.notFound = true;
            return;
        }
        this.loading = true;
        this.ChangelogModel.getEntry(id)
            .then(function (response) {
            _this.entry = response.entry;
            _this.loading = false;
        })
            .catch(function (response) {
            if (response && response.status === 404) {
                _this.notFound = true;
            }
            else {
                _this.error = "Failed to load this update.";
            }
            _this.loading = false;
        });
    };
    return ChangelogEntryController;
}());
ChangelogEntryController.$inject = ["ChangelogModel", "$state", "$stateParams"];
exports.default = ChangelogEntryController;
